/* ACC Technology - actualización segura del contador y total del carrito
   Evita MutationObserver/polling infinito. Solo consulta /cart.js al cargar
   y después de cambios reales del carrito: add/change/update/clear. */
(function () {
  if (window.__acctCartStatusLoaded) return;
  window.__acctCartStatusLoaded = true;

  let refreshTimer = null;
  let refreshPromise = null;

  function formatMoneyMXN(cents) {
    const amount = (Number(cents) || 0) / 100;
    return amount.toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function ensureBubble(cart) {
    const icon = document.querySelector('#cart-icon-bubble');
    if (!icon) return null;

    let bubble = icon.querySelector('.cart-count-bubble');

    if ((Number(cart.item_count) || 0) <= 0) {
      if (bubble) bubble.remove();
      return null;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      const visible = document.createElement('span');
      visible.setAttribute('aria-hidden', 'true');
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      bubble.appendChild(visible);
      bubble.appendChild(hidden);
      icon.appendChild(bubble);
    }

    return bubble;
  }

  function renderCartStatus(cart) {
    const count = Number(cart.item_count) || 0;
    const totalText = formatMoneyMXN(cart.total_price);

    const bubble = ensureBubble(cart);
    if (bubble) {
      const visible = bubble.querySelector('span[aria-hidden="true"]');
      const hidden = bubble.querySelector('.visually-hidden');
      if (visible) visible.textContent = count;
      if (hidden) hidden.textContent = count === 1 ? '1 artículo' : `${count} artículos`;
    }

    document.querySelectorAll('#cart-total, .cart-total-top').forEach((el) => {
      el.textContent = totalText;
    });

    document.dispatchEvent(new CustomEvent('acct:cart-status-rendered', { detail: { cart } }));
  }

  function refreshCartStatus() {
    if (refreshPromise) return refreshPromise;

    refreshPromise = fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then((response) => response.json())
      .then((cart) => {
        renderCartStatus(cart);
        return cart;
      })
      .catch((error) => {
        console.warn('[ACCTECH] No se pudo actualizar el contador del carrito:', error);
      })
      .finally(() => {
        refreshPromise = null;
      });

    return refreshPromise;
  }

  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCartStatus, typeof delay === 'number' ? delay : 250);
  }

  window.AcctUpdateCartStatus = scheduleRefresh;

  ['cart:refresh', 'cart:updated', 'cart:change', 'acct:cart-changed'].forEach((eventName) => {
    document.addEventListener(eventName, () => scheduleRefresh(150));
  });

  // Detecta cambios reales hechos por fetch, sin observar cambios visuales del DOM.
  const originalFetch = window.fetch;
  if (typeof originalFetch === 'function' && !window.__acctCartFetchPatched) {
    window.__acctCartFetchPatched = true;
    window.fetch = function () {
      const args = arguments;
      const request = args[0];
      const url = typeof request === 'string' ? request : request && request.url;
      const isCartMutation = typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);

      return originalFetch.apply(this, args).then((response) => {
        if (isCartMutation) scheduleRefresh(300);
        return response;
      });
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleRefresh(0));
  } else {
    scheduleRefresh(0);
  }
})();
